import { postToApi } from '..'

export async function refreshTokenApi(sessionToken: string) {
  return await postToApi('staking/auth/refresh_token', {
    session_token: sessionToken,
  })
}
